import { type TransactionHash, TRANSACTION_TYPES, EVENT_SUFFIXES } from "@/types";
import { createEventEmitter } from "@/events";

export const CANCEL_EXIT_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.CANCEL_EXIT}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface CancelExitSuccessPayload {
    transactionHash: TransactionHash;
    newUnwindingEpochs: number;
}

export interface CancelExitEventPayloads extends Record<string, unknown> {
    [CANCEL_EXIT_EVENTS.SUCCESS]: CancelExitSuccessPayload;
}

export const cancelExitEventEmitter = createEventEmitter<CancelExitEventPayloads>();
